<div class="standardFlex">
    <h4>{{title}}</h4>
    <textarea [ngModel]="displayContent" disabled></textarea>
    <button mat-button mat-dialog-close>Close</button>
</div>
